/**
 * FILE: apps/hub/src/hooks/mutations/useCourseAttemptMutations.ts
 * PURPOSE: Shared TanStack Query mutation hooks for Course Attempts.
 */

import { useMutationWithToast } from '@/hooks/useMutationWithToast'
import { QK } from '@/lib/queryKeys'
import { addManualCourseAttempt } from '@fintree/supabase/course-attempts'

export function useAddManualCourseAttempt(options?: { onSuccess?: () => void }) {
  return useMutationWithToast({
    mutationFn: (payload: { course: string; attempt: string }) =>
      addManualCourseAttempt(payload.course, payload.attempt),
    successMessage: 'Manual attempt added to registry',
    invalidateKeys: [() => QK.courseAttemptsAll()],
    onSuccess: options?.onSuccess,
  })
}
